import { useEffect, useState } from "react";

// Eigendomsinformatie per projectperceel (GET .../ownership). De sleutels van
// `summary` zijn opgeslagen data en blijven Nederlands; KIK levert veldwaarden
// als tekst, de PDF-parser als lijst van regels.
export type OwnershipRight = {
  nummer?: string;
  titel?: string;
  velden?: Record<string, string | string[]>;
};

export type OwnershipSummary = {
  kadastrale_aanduiding?: string;
  kadastrale_grootte_m2?: number;
  koopsom_eur?: number;
  koopjaar?: number;
  rechten?: OwnershipRight[];
  aantekeningen?: { aard: string; omschrijving: string }[];
  overgegaan_in?: string[];
};

export type Ownership = {
  parcelId: number;
  parcelName: string;
  source: "kik-inzage" | "pdf";
  deliveredAt?: string | null;
  currentAsOf?: string | null;
  fileUrl?: string | null;
  summary: OwnershipSummary;
};

/** De eigendomsinformatie achter `url`; undefined zolang er niets is (nog
 * niet geladen, geen url, of een fout: dan toont het rapport niets). */
export const useOwnership = (url?: string) => {
  const [rows, setRows] = useState<Ownership[] | undefined>();
  useEffect(() => {
    setRows(undefined);
    if (!url) return;
    let active = true;
    fetch(url)
      .then((r) => (r.ok ? r.json() : undefined))
      .then((data) => active && setRows(data))
      .catch(() => active && setRows(undefined));
    return () => {
      active = false;
    };
  }, [url]);
  return rows;
};
